var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2","key":0}),React.createElement("circle",{"cx":"12","cy":"7","r":"4","key":1})]);
}

User.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-user"};

module.exports = User;

User.default = User;
